// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import router from './router'
import '../static/js/index'
import {
  Button,  Cell,  CellGroup,  Col,  Row,  Field,  Tab,  Tabs,
  Dialog,  Toast,  List,  PullRefresh,  Picker,  Popup,  Tag,  DatetimePicker,  Icon,
  DropdownMenu , DropdownItem,Calendar,Grid, GridItem
} from 'vant';
import moment from 'moment'
import store from "./store/index";

Vue.config.productionTip = false
Vue.prototype.isDevelopment = process.env.NODE_ENV === 'development';

Vue.use(VueRouter);
Vue.use(Button).use(Cell).use(CellGroup).use(Col).use(Row).use(Field).use(Tab).use(Tabs)
  .use(Dialog).use(Toast).use(List).use(PullRefresh).use(Picker).use(Popup).use(Tag).use(DatetimePicker).use(Icon)
  .use(DropdownMenu).use(DropdownItem).use(Calendar).use(Grid).use(GridItem);

Vue.filter('dateformat', function(dataStr, pattern = 'YYYY-MM-DD') {
  return moment(dataStr).format(pattern)

})
// router.beforeEach((to, from, next) => {
//   // console.log(to,from)
//   // 页面跳转时增加登录状态判断
//   // if(to.fullPath.indexOf('/Login')==-1 && (!sessionStorage.userId||!sessionStorage.token)){
//     if(to.fullPath.indexOf('/Login')==-1 && (!localStorage.userId||!localStorage.token)){
//       next({
//         path: '/Login',
//         query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
//       })
//   }else{
//     next();
//   }
// });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})

Vue.prototype.$moment = moment;
// moment.locale("zh-cn");



// WEBPACK FOOTER //
// ./src/main.js